export default __webpack_public_path__ + "static/media/not-found.960674ca.svg";